import * as React from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import Navbar from "./components/NavBar";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import DeviceSettingPage from "./pages/DeviceSetting";
import Logout from "./components/Logout";
import Devices from "./pages/Devices";
import MarketingZone from "./pages/MarketingZone";

import Protected from "./components/Protected";
import "./App.css";
import RequestDetailContent from "./pages/RequestDetails";
import AssignedDetailContent from "./pages/AssignedDetail";
import { ConfigProvider, Spin } from "antd";

import "react-data-grid/lib/styles.css";

const SensorQCBatches = React.lazy(() => import("./pages/SensorQC/SensorQCBatches"));
const SensorQCBatchDetail = React.lazy(() => import("./pages/SensorQC/SensorQCBatchDetail"));
const SensorQCTestDetail = React.lazy(() => import("./pages/SensorQC/SensorQCTestDetail"));
const SensorQCPresets = React.lazy(() => import("./pages/SensorQC/SensorQCPresets"));
const SensorQCProvider = React.lazy(() => import("./components/sensor-qc/SensorQCProvider"));

const App = () => (
  <React.Suspense fallback={<Spin />}>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#4680FF",
          borderRadius: 4,

          colorPrimaryHover: "#0078FF",
          colorText: "#262626",
          colorTextSecondary: "#6e6e6e",
        },
        components: {
          Form: {
            ItemLabel: {
              fontWeight: "bold", // Set the font weight for form labels here
            },
          },
          Table: {
            rowHoverBg: "#F2F8FF",
          },
        },
      }}
    >
      <Navbar />
      <Outlet />
    </ConfigProvider>
  </React.Suspense>
);

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    element: (
      <Protected>
        <App />
      </Protected>
    ),
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "warehouse",
        element: <Devices />,
      },
      {
        path: "iot-dashboard",
        element: <DeviceSettingPage />,
      },
      {
        path: "logout",
        element: <Logout />,
      },
      {
        path: "marketing-zone",
        element: <MarketingZone />
      },
      // {
      //   path: "map",
      //   element: <Maps />
      // },
      // {
      //   path: "requests",
      //   element: <RequestContent />
      // },
      // {
      //   path: "assigned",
      //   element: <AssignedContent />
      // },
      {
        path: "warehouse-detail",
        element: <Devices />,
      },
      {
        path: "sensor-qc",
        element: <SensorQCProvider />,
        children: [
          { index: true, element: <SensorQCBatches /> },
          { path: "batches/:batchId", element: <SensorQCBatchDetail /> },
          { path: "tests/:testId", element: <SensorQCTestDetail /> },
          { path: "presets", element: <SensorQCPresets /> },
        ],
      },
      {
        path: "request-detail/noti/:request_id/type/:request_type",
        element: <RequestDetailContent />,
      },
      {
        path: "assign-detail/noti/:request_id/type/:request_type",
        element: <AssignedDetailContent />,
      },
    ],
  },
]);
